export enum ReadWriteAccess {
  AccessDenied = -1,
  Readonly = 0,
  CanEdit = 1,
}
